import { Page } from './pages';

import { PATH } from '../../../constants';

export default {
  component: Page,
  name: 'Temperature',
  path: PATH.PROFILES_TEMPERATURE,
  exact: false,
  isPrivate: true,
  roles: []
};
